import { render, staticRenderFns } from "./Si.vue?vue&type=template&id=74577b71&"
import script from "./Si.vue?vue&type=script&lang=js&"
export * from "./Si.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports